import * as React from "react";
import * as ReactDOM from "react-dom";
import { EmailSubscriptionInfo, EmailSubscription } from '../Generated/RestClient';
import { resourceStrings } from "../../../Intercom.ReactUI/Views/Strings";
import { CountryCodeOptInOut, OptingOptions } from '../Utils/PromotionEmailUtils';

/**
 * List of disabled country codes for consent collection
 */
const DISABLED_COUNTRY_CODES = {'RU': true};

export interface EmailSubscriptionConsentFormFieldsProps  {
    subscriptionInfo: EmailSubscriptionInfo;
    onSubscriptionChanged?: (EmailSubscriptionInfo) => any;
}

export interface EmailSubscriptionConsentFormFieldsState  {
    showCountryDropdown?: boolean;
}

export class EmailSubscriptionConsentFormFields extends React.Component<EmailSubscriptionConsentFormFieldsProps, EmailSubscriptionConsentFormFieldsState> {
    constructor(props?: EmailSubscriptionConsentFormFieldsProps, context?: any) {
        super(props, context);
        this.state = this.prepareState(props);
    }

    private triggerSubscriptionStateChanged = () => {
        if (this.props.onSubscriptionChanged) {
            this.props.onSubscriptionChanged(this.props.subscriptionInfo);
        }
    }

    private onCountryChanged = (e: React.FormEvent<any>) => {
        let countryCode: string = $(e.target).val();
        let subscription = this.props.subscriptionInfo;
        subscription.CountryCode = countryCode;
        
        if (CountryCodeOptInOut[countryCode]) {
            let enabled = CountryCodeOptInOut[countryCode] == OptingOptions.OptOut ||
                          CountryCodeOptInOut[countryCode] == OptingOptions.Notice;
            subscription.IsEnabled = enabled;
            subscription.SubscriptionType = CountryCodeOptInOut[countryCode];
        } else {
            subscription.IsEnabled = false;
            subscription.SubscriptionType = null;
        }

        this.forceUpdate(this.triggerSubscriptionStateChanged);
    }

    private onAllowPromotionalEmail = (e: React.FormEvent<any>) => {
        let t: any = e.target;
        let subscription = this.props.subscriptionInfo;
        subscription.IsEnabled = t.checked;
        this.forceUpdate(this.triggerSubscriptionStateChanged);
    }

    private prepareState(props: EmailSubscriptionConsentFormFieldsProps): EmailSubscriptionConsentFormFieldsState {
        let state = {
            showCountryDropdown: true,
            termsAgreed: false
        } as EmailSubscriptionConsentFormFieldsState;

        if (props && props.subscriptionInfo && props.subscriptionInfo.CountryCode) {
            state.showCountryDropdown = false;
        }

        return state;
    }
    
    private renderCountryOptions(): JSX.Element[] {
        return _.chain<any>(MsMarkets.markets)
                .pairs()
                .filter(tuple => {
                    let [countryCode] = tuple;
                    return DISABLED_COUNTRY_CODES[countryCode] !== true
                })
                .map((p) => {
                    let label = p[1];
                    let value = p[0];
                    return <option key={value} value={value}>{label}</option>;
                })
                .value();
    }

    private renderCountryDropdown(selectedCountry: string): JSX.Element {
        // - Do not return any list if show country dropdown is disabled 
        if (!this.state.showCountryDropdown) {
            return null;
        }

        let defaultOption: JSX.Element = <option value=""></option>;
        if (selectedCountry) {
            defaultOption = null;
        }

        return <div className="country-selection">
            <div className="country-label">
                {resourceStrings.subscriptionConsentDialog.selectCountryLabel}
            </div>
            <select id="country-select"
                    key="country-select" 
                    className="country-select"
                    defaultValue={selectedCountry} 
                    onChange={this.onCountryChanged}>
                {defaultOption}
                {this.renderCountryOptions()}
            </select>
        </div>;
    }

    private getPromotionLabelContent(countryCode: string) {
        let html = resourceStrings.subscriptionConsentDialog.allowPromotionalEmailLabelHtml;
        let countrySpecificMap = resourceStrings.subscriptionConsentDialog.countrySpecificPromotionalEmailLablesHtml;
        if (countrySpecificMap[countryCode]) {
            html = countrySpecificMap[countryCode]
        }

        return {
            __html: html
        }
    }

    public render() {
        let subInfo = this.props.subscriptionInfo;
        let countryCode = subInfo.CountryCode && subInfo.CountryCode.toUpperCase();
            
        return <div className="email-consent-fields">
            {this.renderCountryDropdown(countryCode)}

            <div className="checkbox-row">
                <div className="checkbox-container">
                    <input 
                        type="checkbox"
                        key="allowPromotionalEmail" 
                        id="allowPromotionalEmail" 
                        ref="allowPromotionalEmail" 
                        value="allow"
                        checked={this.props.subscriptionInfo.IsEnabled}
                        onChange={this.onAllowPromotionalEmail} />
                </div>
                <div className="label-container"> 
                    <label htmlFor="allowPromotionalEmail" dangerouslySetInnerHTML={this.getPromotionLabelContent(countryCode)} />
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./Client/Views/EmailSubscriptionConsentFormFields.tsx